/**
 * BrandingFooter - Conditional branding display based on photographer's subscription tier
 * 
 * Branding Rules:
 * - Starter/Pro tiers: Show "Built by 360Lumina" on all pages
 * - Studio/Legacy tiers: Show nothing on external/client-facing pages
 *                        (Can be shown internally if isInternal=true)
 * 
 * Props:
 * - planKey: The photographer's subscription tier (starter, pro, studio, legacy)
 * - className: Additional CSS classes
 * - isInternal: If true, shows branding even for Studio/Legacy (default: false)
 */
import { Link } from "react-router-dom";

const BrandingFooter = ({ planKey, className = "", isInternal = false }) => {
  // For Studio and Legacy tiers, hide branding on external/client-facing pages
  const isHighTier = planKey === "studio" || planKey === "legacy";
  
  // Hide branding for high tiers unless explicitly marked as internal
  if (isHighTier && !isInternal) {
    return null;
  }
  
  return (
    <span className={`text-muted-foreground ${className}`} data-testid="branding-footer">
      Built by{" "}
      <Link 
        to="/" 
        className="text-primary/70 hover:text-primary transition-colors"
        target="_blank"
        rel="noopener noreferrer"
      >
        360Lumina
      </Link>
    </span>
  );
};

export default BrandingFooter;
